import gsap from 'gsap'

export default class Search {
  constructor() {
    this.items = document.querySelectorAll('.js-search-item')
    this.loadMoreBtn = document.querySelector('.js-load-more')
    this.loadMoreContainer = document.querySelector('.search-page__loadmore')
    this.itemsPerPage = 10
    this.currentIndex = 0

    if (this.items.length > 0) {
      this.init()
    }
  }

  init() {
    this.hideAllItems()
    this.showItems(false)

    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', () => this.showItems(true))
    }
  }

  hideAllItems() {
    this.items.forEach((item) => {
      item.style.display = 'none'
    })
  }

  showItems(shouldScroll = true) {
    const startIndex = this.currentIndex
    const nextIndex = this.currentIndex + this.itemsPerPage

    for (let i = startIndex; i < nextIndex; i++) {
      if (this.items[i]) {
        this.items[i].style.display = 'block'

        gsap.fromTo(this.items[i], {
          opacity: 0,
          y: 10
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power3.out'
        })
      }
    }

    this.currentIndex = nextIndex

    if (this.currentIndex >= this.items.length && this.loadMoreBtn) {
      this.loadMoreBtn.style.display = 'none'

      if (this.loadMoreContainer) {
        this.loadMoreContainer.style.display = 'none'
      }
    }

    if (shouldScroll && this.items[startIndex]) {
      const elementTop = this.items[startIndex].getBoundingClientRect().top + window.pageYOffset

      gsap.to(window, {
        duration: 2,
        scrollTo: {
          y: elementTop - 100,
          autoKill: false
        },
        ease: 'power3.out'
      })
    }
  }
}
